import moment from 'moment/moment';
import useLatestConversationList from './useLatestConversationList';
/**
 * Get user-details for the current user, that is provided in the conversation
 * */
var getUserDetailsInConversation = function (userId, conversation) {
    if (userId === conversation.sender.id) {
        return conversation.sender;
    }
    return conversation.recipient;
};
var isUnread = function (conversation, user) {
    var latestMessage = conversation.latestMessage;
    // Your own messages does not count
    if (latestMessage.senderId === user.id) {
        return false;
    }
    var lastMessageSeen = getUserDetailsInConversation(user.id, conversation).lastMessageSeen;
    // The current user may not have seen any messages in this conversation
    if (!lastMessageSeen) {
        return true;
    }
    var latestMessageCreatedOn = moment(latestMessage.createdOn);
    return latestMessageCreatedOn.isAfter(moment(lastMessageSeen));
};
var useLatestUnreadConversationList = function (user, hasHigherRefreshRate) {
    if (hasHigherRefreshRate === void 0) { hasHigherRefreshRate = false; }
    var _a = useLatestConversationList(hasHigherRefreshRate), error = _a.error, isLoading = _a.isLoading, conversations = _a.conversations;
    if (!user) {
        return { error: error, isLoading: isLoading, conversations: conversations };
    }
    return {
        error: error,
        isLoading: isLoading,
        conversations: conversations.filter(function (conversation) { return (isUnread(conversation, user)); }),
    };
};
export default useLatestUnreadConversationList;
